import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Products: ParentMenuProps = {
  label: 'Products',
  description: 'Run your business with online ordering, payroll, and more',
  heapClass: 'ca_topnav_pdps',
  gridCols: 'grid-cols-4 xl:grid-cols-8 min-[1440px]:pl-[156px]',
  sectionLink: {
    url: '/products',
    label: 'View All Products'
  },
  showcaseMobile: false,
  subMenus: [
    {
      label: 'Front of House',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Point of Sale',
          icon: 'before:content-icon-hardware-flex',
          url: '/products/point-of-sale',
          heapClass: 'ca_nav_pos'
        },
        {
          label: 'Handheld POS',
          icon: 'before:content-icon-toast-go',
          url: '/products/handheld-pos',
          heapClass: 'ca_nav_hhpos'
        },
        {
          label: 'Self-Ordering Kiosk',
          icon: 'before:content-icon-kiosk',
          url: '/hardware/restaurant-kiosk',
          heapClass: 'ca_nav_kiosk'
        },
        {
          label: 'Toast Mobile Order & Pay®',
          icon: 'before:content-icon-software-mobile-order-pay',
          url: '/products/mobile-order-and-pay',
          heapClass: 'ca_nav_mobileorder'
        }
      ]
    },
    {
      label: 'Back of House',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Kitchen Display System',
          icon: 'before:content-icon-flex-for-kitchen-2',
          url: '/hardware/kitchen-display-system',
          heapClass: 'ca_nav_kds'
        }
      ]
    },
    {
      label: 'Digital Guest Engagement',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Email Marketing',
          icon: 'before:content-icon-software-email-marketing',
          url: '/products/toast-marketing',
          heapClass: 'ca_nav_email'
        },
        {
          label: 'Loyalty',
          icon: 'before:content-icon-solutions-loyalty',
          url: '/products/loyalty',
          heapClass: 'ca_nav_loyalty'
        },
        {
          label: 'Online Ordering',
          icon: 'before:content-icon-software-online-ordering',
          url: '/products/online-ordering',
          heapClass: 'ca_nav_oo'
        },
        {
          label: 'Reservations & Waitlist',
          icon: 'before:content-icon-solutions-tables',
          url: '/products/reservations-and-waitlist',
          heapClass: 'ca_nav_tables'
        },
        {
          label: 'Gift Cards',
          icon: 'before:content-icon-gift-card',
          url: '/products/gift-card',
          heapClass: 'ca_nav_giftcards'
        }
      ]
    },
    {
      label: 'Back Office & Team Management',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Scheduling',
          icon: 'before:content-icon-scheduling',
          url: '/products/restaurant-employee-scheduling-software',
          heapClass: 'ca_nav_scheduling'
        },
        {
          label: 'Reporting',
          icon: 'before:content-icon-reporting-analytics',
          url: '/products/reporting',
          heapClass: 'ca_nav_reporting'
        },
        {
          label: 'Multilocation Management',
          icon: 'before:content-icon-multi-location-management',
          url: '/products/multi-location-management',
          heapClass: 'ca_nav_mlm'
        },
        {
          label: 'Payment Processing',
          icon: 'before:content-icon-payment-processing',
          url: '/products/payments',
          heapClass: 'ca_nav_paymentproc'
        }
      ]
    }
  ]
}

export default Products
